// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';

// Components
import { DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Dropdown from 'components/atoms/Dropdown';
import { TextField } from 'components/api';
import { Icon } from 'components/atoms/Icon/';

// Types
import type { ContactInfo } from 'api/xws/login/entities/ContactInfo';
import type { PersonInfo } from 'api/xws/login/entities/PersonInfo';

// Utils
import { formatPhoneNumber, isPhoneNumberValid } from 'utils/string';

// Constants
import { WAITING_OPTIONS } from 'constants/selfCheckIn';

import './ContactPreference.scss';

const { CALL, TEXT } = WAITING_OPTIONS;
const ns = 'contact-preference';

type Props = {
  setMobilePhoneNumber: (phone: string) => void,
  setWaitState: (waitState: string) => void,
  setCustomerMobileNumber: (phone: string) => void,
  dealerCountryCode: string,
  onDropdownCallback: (option: string, label: string) => void,
  intl: IntlShape,
  contactInfo: ContactInfo,
  selectedOptionLabel: string,
  error: boolean,
  uppercaseOptions: boolean,
  personInfo: PersonInfo,
  customerMobileNumber: string,
  gtmContactPreferenceNumberChange: (phone: number) => void
};

export default class ContactPreference extends React.Component<Props> {
  constructor(props: Props) {
    super();
  }

  componentDidMount() {
    const {
      personInfo,
      setMobilePhoneNumber,
      setCustomerMobileNumber,
      customerMobileNumber
    } = this.props;
    const personInfoNumber = personInfo ? personInfo.mobilePhone : '';
    const mobilePhoneNumber = customerMobileNumber || personInfoNumber || '';
    setMobilePhoneNumber(mobilePhoneNumber + '');
    setCustomerMobileNumber(mobilePhoneNumber + '');
  }

  onMobilePhoneChange = (event: Object) => {
    const {
      setMobilePhoneNumber,
      setCustomerMobileNumber,
      dealerCountryCode,
      gtmContactPreferenceNumberChange
    } = this.props;
    const value = event.target.value.replace(/[^0-9]/g, '');
    setMobilePhoneNumber(value);
    if (isPhoneNumberValid(value, dealerCountryCode)) {
      setCustomerMobileNumber(value + '');
      gtmContactPreferenceNumberChange(value);
    }
  };

  onDropdownSelect = (option: string, label: string) => {
    const { setWaitState, onDropdownCallback } = this.props;
    if (onDropdownCallback) {
      onDropdownCallback(option, label);
    }
    if (option === TEXT) {
      setWaitState(TEXT);
    } else if (option === CALL) {
      setWaitState(CALL);
    }
  };

  createDropdownMenu = () => {
    const { intl } = this.props;
    const call = intl.formatMessage({
      id: 'c8.self.check.in.advisor.page.call'
    });
    const text = intl.formatMessage({
      id: 'c8.self.check.in.advisor.page.text'
    });
    return (
      <DropdownMenu>
        <DropdownItem onClick={() => this.onDropdownSelect(CALL, call)}>
          {call}
        </DropdownItem>
        <DropdownItem onClick={() => this.onDropdownSelect(TEXT, text)}>
          {text}
        </DropdownItem>
      </DropdownMenu>
    );
  };

  render() {
    const {
      intl,
      contactInfo,
      dealerCountryCode,
      selectedOptionLabel,
      error,
      uppercaseOptions
    } = this.props;
    const mobilePhoneNumber = contactInfo ? contactInfo.mobilePhone : '';
    const uppercaseDropdown = uppercaseOptions
      ? `${ns}--uppercase-dropdown`
      : '';
    const inputClass = error
      ? `${ns}__mobile-phone-input--error`
      : `${ns}__mobile-phone-input`;

    return (
      <div className={`${ns}`}>
        <p className={`${ns}__subtitle`}>
          {intl.formatMessage({
            id: 'c8.self.check.in.advisor.page.contact.preference'
          })}
        </p>
        <Dropdown className={`${ns}__dropdown`}>
          <DropdownToggle className={uppercaseDropdown} caret>
            {selectedOptionLabel} <Icon type="chevron__down" />
          </DropdownToggle>
          {this.createDropdownMenu()}
        </Dropdown>
        <span>
          <TextField
            className={inputClass}
            name="mobile_phone_input"
            placeholder={intl.formatMessage({
              id: 'c8.self.check.in.advisor.page.enter.mobile.number',
              defaultMessage: 'Enter mobile number'
            })}
            type="tel"
            onChange={e => this.onMobilePhoneChange(e)}
            value={formatPhoneNumber(mobilePhoneNumber, dealerCountryCode)}
          />
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ContactPreference/ContactPreference.js